import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { SessionContext } from "@/providers";
import { SocialCoachSession } from "@/services/bedrock";
import { buildSignInUrl } from "@/utils/loginRedirect";

type LegacyRedirectProps = RouteComponentProps<{ [key: string]: string }> & {
  getTo: (
    session: SocialCoachSession | undefined,
    routeProps: RouteComponentProps<{ [key: string]: string }>
  ) => string;
};

export const LegacyRedirectRoute: React.FC<LegacyRedirectProps> = ({ getTo, ...routeProps }) => {
  return (
    <SessionContext.Consumer>
      {({ session, loading }) => {
        if (loading) {
          return <Loader active size="large" />;
        }

        if (!session) {
          const { pathname, search, hash } = routeProps.location;
          return <Redirect to={buildSignInUrl(`${pathname}${search}${hash}`)} />;
        }

        const to = getTo(session, routeProps);
        return <Redirect exact to={to} />;
      }}
    </SessionContext.Consumer>
  );
};
